import Vue from 'vue'
import Init from '../views/Init.vue'
import MessageSent from '../views/MessageSent.vue'
import CartDesktop from '../views/CartDesktop.vue'
import OrderCompleted from '../views/OrderCompleted.vue'
import OrderCompletedStripe from '../views/OrderCompletedStripe.vue'
import OrderCancelled from '../views/OrderCancelled.vue'
import OrderCancelledStripe from '../views/OrderCancelledStripe.vue'
import OrderReserved from '../views/OrderReserved.vue'
import ConfiguratorDesktop from '../views/ConfiguratorDesktop.vue'
import Faq from '../views/Faq.vue'
import Impressum from '../views/Impressum.vue'
import Datenschutz from '../views/Datasecurity.vue'
import VueRouter from 'vue-router'

import Store from '../store/index.js'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/messageSent',
    name: 'MessageSent',
    component: MessageSent
  },
  {
    path: '/',
    name: 'root',
    component: Init
  },
  {
    path: '/cartDesktop',
    name: 'CartDesktop',
    component: CartDesktop,
    meta: {title: 'cart'}
  },
  {
    path: '/orderCompleted',
    name: 'OrderCompleted',
    component: OrderCompleted,
    meta: {title: 'orderCompleted'}
  },
  {
    path: '/orderCompletedStripe',
    name: 'OrderCompletedStripe',
    component: OrderCompletedStripe,
    meta: {title: 'orderCompletedStripe'}
  },
  {
    path: '/orderCancelled',
    name: 'OrderCancelled',
    component: OrderCancelled,
    meta: {title: 'orderCancelled'}
  },
  {
    path: '/orderCancelledStripe',
    name: 'OrderCancelledStripe',
    component: OrderCancelledStripe,
    meta: {title: 'orderCancelledStripe'}
  },
  {
    path: '/orderReserved',
    name: 'OrderReserved',
    component: OrderReserved,
    meta: {title: 'orderReserved'}
  },
  {
    path: '/configuratorDesktop',
    name: 'configuratorDesktop',
    component: ConfiguratorDesktop,
    meta: {title: 'configurator entry: choose desired furniture'}
  },
  {
    path: '/faq',
    name: 'Faq',
    component: Faq,
    meta: {title: 'FAQ'}
  },
  {
    path: '/impressum',
    name: 'Impressum',
    component: Impressum,
    meta: {title: 'imprint'}
  },
  {
    path: '/datasecurity',
    name: 'Datenschutz',
    component: Datenschutz,
    meta: {title: 'data security'}
  },
  {
    path: '/tisch',
    name: 'referralTable',
    component: Init,
    props: { path: "table" }
  },
  {
    path: '/bank',
    name: 'referralBench',
    component: Init,
    props: { path: "bench" }
  },
  {
    path: '/regal',
    name: 'referralShelf',
    component: Init,
    props: { path: "shelf" }
  },
  {
    path: '/hocker',
    name: 'referralStool',
    component: Init,
    props: { path: "stool" }
  },



  {
    path: '/bienen',
    name: 'Bees',
    component: () => import(/* webpackChunkName: "Bees" */ '../views/Bees.vue')
  },
  {
    path: '/bees',
    name: 'Bees',
    component: () => import(/* webpackChunkName: "Bees" */ '../views/Bees.vue')
  },
  {
    path: '/homeDesktop',
    name: 'HomeDesktop',
    component: () => import(/* webpackChunkName: "HomeDesktop" */ '../views/HomeDesktop.vue'),
    meta: {title: 'main page desktop'}
  },
  {
    path: '/homeMobile',
    name: 'HomeMobile',
    component: () => import(/* webpackChunkName: "HomeMobile" */ '../views/HomeMobile.vue'),
    meta: {title: 'main page mobile'}
  },
  {
    path: '/configuratorTableDesktop',
    name: 'configuratorTableDesktop',
    component: () => import(/* webpackChunkName: "ConfiguratorTableDesktop" */ '../views/ConfiguratorTableDesktop.vue'),
    meta: {title: 'table configurator desktop'}
  },
  {
    path: '/configuratorTableMobile',
    name: 'configuratorTableMobile',
    component: () => import(/* webpackChunkName: "ConfiguratorTableMobile" */ '../views/ConfiguratorTableMobile.vue'),
    meta: {title: 'table configurator mobile'}
  },
  {
    path: '/configuratorFrameDesktop',
    name: 'configuratorFrameDesktop',
    component: () => import(/* webpackChunkName: "ConfiguratorFrameDesktop" */ '../views/ConfiguratorFrameDesktop.vue'),
    meta: {title: 'frame configurator desktop'}
  },
  {
    path: '/configuratorFrameMobile',
    name: 'configuratorFrameMobile',
    component: () => import(/* webpackChunkName: "ConfiguratorFrameMobile" */ '../views/ConfiguratorFrameMobile.vue'),
    meta: {title: 'frame configurator mobile'}
  },
  {
    path: '/configuratorTableOfficeDesktop',
    name: 'configuratorTableOfficeDesktop',
    component: () => import(/* webpackChunkName: "ConfiguratorTableOfficeDesktop" */ '../views/ConfiguratorTableOfficeDesktop.vue'),
    meta: {title: 'office table configurator desktop'}
  },
  {
    path: '/configuratorTableOfficeMobile',
    name: 'configuratorTableOfficeMobile',
    component: () => import(/* webpackChunkName: "ConfiguratorTableOfficeMobile" */ '../views/ConfiguratorTableOfficeMobile.vue'),
    meta: {title: 'office table configurator mobile'}
  },
  {
    path: '/configuratorBenchDesktop',
    name: 'configuratorBenchDesktop',
    component: () => import(/* webpackChunkName: "ConfiguratorBenchDesktop" */ '../views/ConfiguratorBenchDesktop.vue'),
    meta: {title: 'bench configurator desktop'}
  },
  {
    path: '/configuratorBenchMobile',
    name: 'configuratorBenchMobile',
    component: () => import(/* webpackChunkName: "ConfiguratorBenchMobile" */ '../views/ConfiguratorBenchMobile.vue'),
    meta: {title: 'bench configurator mobile'}
  },
  {
    path: '/configuratorStoolDesktop',
    name: 'configuratorStoolDesktop',
    component: () => import(/* webpackChunkName: "ConfiguratorStoolDesktop" */ '../views/ConfiguratorStoolDesktop.vue'),
    meta: {title: 'stool configurator desktop'}
  },
  {
    path: '/configuratorStoolMobile',
    name: 'configuratorStoolMobile',
    component: () => import(/* webpackChunkName: "ConfiguratorStoolMobile" */ '../views/ConfiguratorStoolMobile.vue'),
    meta: {title: 'stool configurator mobile'}
  },
  {
    path: '/configuratorShelfMobile',
    name: 'configuratorShelfMobile',
    component: () => import(/* webpackChunkName: "ConfiguratorShelfMobile" */ '../views/ConfiguratorShelfMobile.vue'),
    meta: {title: 'shelf configurator desktop'}
  },
  {
    path: '/configuratorShelfDesktop',
    name: 'configuratorShelfDesktop',
    component: () => import(/* webpackChunkName: "ConfiguratorShelfDesktop" */ '../views/ConfiguratorShelfDesktop.vue'),
    meta: {title: 'shelf configurator mobile'}
  },
  {
    path: '/sustainabilityDesktop',
    name: 'sustainabilityDesktop',
    component: () => import(/* webpackChunkName: "SustainabilityDesktop" */ '../views/SustainabilityDesktop.vue'),
    meta: {title: 'information about sustainability'}
  },
  {
    path: '/about',
    name: 'About',
    component: () => import(/* webpackChunkName: "About" */ '../views/About.vue'),
    meta: {title: 'about us page'}
  }
]

const router = new VueRouter({
  mode: 'history',
  // base: process.env.BASE_URL,
  routes
})

async function asyncCall() {
  const result = await Store.getters.getSavedOrder;
  Store.dispatch("setStripeOrder", result.order);
}

router.beforeEach((to, from, next) => {
  if (from.name == null && to.name == "CartDesktop"){
    asyncCall()
  }
  next()
})

export default router
